import { render, staticRenderFns } from "./CustomerVaultList.vue?vue&type=template&id=69d5e40c&"
import script from "./CustomerVaultList.vue?vue&type=script&lang=js&"
export * from "./CustomerVaultList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports